'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _components = require('components');

var _GenericSettings = require('redux/modules/GenericSettings');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
    var inputs = state.genericSettings.oldCFA.inputs;
    var nonDeletedInputs = [];
    (0, _keys2.default)(inputs).forEach(function (id) {
        if (!state.genericSettings.oldCFA.inputs[id].pendingServerDeletion) {
            nonDeletedInputs.push(id);
        }
    });
    return {
        inputs: nonDeletedInputs
    };
};

var mapDispatchToProps = {
    createInput: _GenericSettings.createInput
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_components.InputParameters);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/InputParameters/InputParameters.js
// module id = 1631
// module chunks = 0